import { InjectionToken } from '@angular/core';
import type { SystemStatusConfiguration } from './system-status.domain';

export const SYSTEM_STATUS_CONFIGURATION = new InjectionToken<SystemStatusConfiguration>('systemStatusConfiguration');

